import { resetActiveTollSection } from './resetActiveTollSection';
import { setActiveTollSection } from './setActiveTollSection';

export const tollOperations = {
  setActiveTollSection,
  resetActiveTollSection,
};
